import { ModalService } from './../../../../../services/modal.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { Constants } from 'src/app/data/constants/constants.enum';
import { CreativeProductIdPrice } from 'src/app/data/constants/creative-productid-price.enum';
import { GoalType } from 'src/app/data/constants/goal-type.const';

import { CampaignVO } from 'src/app/data/vo/CampaignVO';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import { NameValuePairVO } from 'src/app/data/vo/NameValuePairVO';
import { PricingSummaryVO } from 'src/app/data/vo/PricingSummaryVO';
import { environment } from 'src/environments/environment';
import { MediaPlanOptionVO, MediaPlanType } from '../../../../../data/vo/MediaPlanOptionVO';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { CreativeProductIdMap } from 'src/app/data/constants/creative-produce.const';
import { OrderStatus } from 'src/app/data/constants/orderStatus.enum';
import { PaymentOverallStatus } from 'src/app/data/constants/payment-status.enum';
import { OrderVO } from 'src/app/data/vo/OrderVO';

@Component({
  selector: 'campaign-review',
  templateUrl: './campaign-review.component.html',
  styleUrls: ['./campaign-review.component.scss']
})
export class CampaignReviewComponent implements OnInit {


  @Input() campaignVO: CampaignVO;
  @Input() set isReviewOrderSummary(value: boolean) {
    if (value && this._isReviewOrderSummary != undefined) {
      this.getCampaignPricingSummary();
    } else if (this.appliedDiscountCode) {
      // clear previous applied code if there is back action
      this.appliedDiscountCode = undefined;
    }
    this._isReviewOrderSummary = value;
  }
  @Input() paymentType: string;
  @Input() orderStatus: string;
  @Input() previousPaidOrder: OrderVO;
  @Output() onPaymentChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onPricingSummaryChange: EventEmitter<PricingSummaryVO> = new EventEmitter<PricingSummaryVO>();
  _isReviewOrderSummary: boolean;
  orderStatusEnum = OrderStatus;
  get isReviewOrderSummary(): boolean {
    return this._isReviewOrderSummary;
  }
  campaignBudgetSize: number = Constants.CAMPAIGN_BUDGET_SIZE;
  CreativeProductPrice = CreativeProductIdPrice;
  mediaPlans: Array<MediaPlanOptionVO> = [];
  mediaPlanDescriptions: any = {
    Standard: 'A cost-effective media plan that gives you access to the full range of Mediacorp content, selected for your audience.',
    Plus: 'Upgraded media plan with at least 25% of budget allocated to ads during prime time.',
    Premium: 'Reach your customers at their prime with at least 50% of budget allocated to ads during prime time.'
  };
  mediaPlanOrder: any = {
    Standard: 1,
    Plus: 2,
    Premium: 3
  };

  selectedPlanDescription: string;
  goal: string;
  buyerCreative: Array<CreativeVO> = [];
  sellerCreative: Array<CreativeVO> = [];
  unpaidCreativeIds: Array<number>;
  platform = environment.platform;
  mediaPlanType = MediaPlanType;
  currencySymbol: string = environment.currency;
  currencyShortSymbol: string = environment.currencySymbol;
  gst: number = environment.gst;
  languages: Array<string> = [];
  channels: Array<string> = [];
  timezoneStr: string = environment.timezone;
  timezoneAbbrStr: string = environment.timezoneAbbr;
  loadingReviewPage: boolean = true;
  creativeDescriptions: Array<any> = [];
  creativeProductIdMap = CreativeProductIdMap;
  pricingSummary: PricingSummaryVO;
  appliedDiscountCode: string;
  disableDiscountCodeButton: boolean;
  enableDiscountFeature: boolean = environment.enableDiscountFeature;
  hasNoCPMData: boolean = false;
  autoFetchMediaPlanCount: number = 3;

  constructor(
    private campaignAdapter: CampaignAdapter,
    private creativeAdapter: CreativeAdapter,
    private modal: ModalService
  ) { }

  ngOnInit() {
    if (this.campaignVO.budget < this.campaignBudgetSize) {
      // need to get media plans for campaigns
      this.getMediaPlans();
    }
    this.campaignAdapter.getLanguages(this.campaignVO.startDate, this.campaignVO.endDate).then((languages: NameValuePairVO[]) => {
      this.languages = _.map(_.filter(languages, lan => _.findIndex(this.campaignVO.languages, ln => ln === lan.value) > -1), 'name');
    });
    this.campaignAdapter.getChannels(this.campaignVO.startDate, this.campaignVO.endDate).then((channels: NameValuePairVO[]) => {
      this.channels = _.map(_.filter(channels, chnl => _.findIndex(this.campaignVO.channels, ch => ch === chnl.value) > -1), 'name');
    });

    if (this.campaignVO.goalType) {
      this.goal = GoalType[this.campaignVO.goalType].label;
    }
    this.creativeAdapter.getCreativeByCampaignId(this.campaignVO.id).then((creativeData: CreativeVO[]) => {
      this.buyerCreative = _.filter(creativeData, { creativeAuthor: 'Buyer' });
      this.sellerCreative = _.filter(creativeData, { creativeAuthor: 'Seller' });
      if (this.previousPaidOrder) {
        this.appliedDiscountCode = this.previousPaidOrder.discountCode;
        this.disableDiscountCodeButton = true;
        this.pricingSummary = this.previousPaidOrder;
        this.getNotPaidCreatives();
        this.onPricingSummaryChange.emit(this.pricingSummary);
      } else if (this.campaignVO.budget < this.campaignBudgetSize) {
        this.getCampaignPricingSummary();
      }
    });
  }

  getMediaPlans() {
    this.hasNoCPMData = false;
    this.campaignAdapter.getMediaPlanOptions(this.campaignVO).then(resp => {
      _.map(_.map(resp, 'cpm'), (cpmValue) => {
        this.hasNoCPMData = this.hasNoCPMData || cpmValue === 0;
      });
      if (this.hasNoCPMData) {
        this.autoFetchMediaPlanCount--;
        if (this.autoFetchMediaPlanCount > 0) {
          this.getMediaPlans();
          return;
        } else {
          this.modal.info({ message: 'Please refresh the page for the Media Plan summary to get updated.' });
          this.loadingReviewPage = false;
        }
      }
      this.autoFetchMediaPlanCount = 3;
      this.mediaPlans = resp.sort((a, b) => this.mediaPlanOrder[a.type] - this.mediaPlanOrder[b.type]);
      if (this.campaignVO.mediaPlanOption) {
        // refresh campaignVO's media plan option in case of new data
        let mediaPlanOption = this.mediaPlans.find((v) => v.type === this.campaignVO.mediaPlanOption.type);
        if (mediaPlanOption) {
          this.changeMediaPlan(mediaPlanOption);
        }
      }
      this.loadingReviewPage = false;
    }).catch((error) => {
      this.loadingReviewPage = false;
    });
  }

  getNotPaidCreatives() {
    if (this.sellerCreative && this.sellerCreative.length && this.pricingSummary.creativesCost &&
      this.pricingSummary.creativesCost.creatives && this.pricingSummary.creativesCost.creatives.length) {
      let creativeIdBudgetMap = {};
      let creativeProductIdCount = {};

      this.pricingSummary.creativesCost.creatives.forEach((v) => {
        creativeIdBudgetMap[v.creativeId] = v.budget;
      });
      this.sellerCreative.forEach((cvo) => {
        if (creativeIdBudgetMap[cvo.creativeId]) {
          // unpaid creative
          if (!creativeProductIdCount[cvo.creative_product_id]) {
            creativeProductIdCount[cvo.creative_product_id] = {
              type: this.creativeProductIdMap[cvo.creative_product_id].type,
              cost: 0,
              quantity: 0
            };
          }
          creativeProductIdCount[cvo.creative_product_id].cost += creativeIdBudgetMap[cvo.creativeId];
          creativeProductIdCount[cvo.creative_product_id].quantity++;
        }
      });
      this.creativeDescriptions = Object.values(creativeProductIdCount);
    }
  }

  onPaymentSelection(type: string) {
    if (type !== this.paymentType) {
      this.paymentType = type;
      this.onPaymentChange.emit(type);
    }
  }

  changeMediaPlan(mediaPlan) {
    this.campaignVO.mediaPlanOption = { ...this.campaignVO.mediaPlanOption, ...mediaPlan };
    this.selectedPlanDescription = this.mediaPlanDescriptions[mediaPlan.type];
  }

  getCampaignPricingSummary(code?: string) {
    let promise = Promise.resolve();
    if (!this.unpaidCreativeIds) {
      if (this.sellerCreative.length) {
        let creativeIds = this.sellerCreative.map((cvo) => cvo.creativeId);
        promise = this.creativeAdapter.getCreativesPaymentStatus(creativeIds).then((creativeStatus) => {
          this.unpaidCreativeIds = [];
          creativeStatus.forEach((cs) => {
            if (cs.status === PaymentOverallStatus.NOT_PAID) {
              this.unpaidCreativeIds.push(cs.creativeId);
            }
          })
        });
      } else {
        this.unpaidCreativeIds = [];
      }
    }
    return promise.then(() => {
      return this.campaignAdapter.getCampaignPricingSummary(this.campaignVO.id, this.unpaidCreativeIds, code, this.campaignVO.budget < this.campaignBudgetSize ? this.campaignVO.mediaPlanOption : undefined).then((summary: PricingSummaryVO) => {
        this.pricingSummary = summary;
        this.getNotPaidCreatives();
        this.onPricingSummaryChange.emit(this.pricingSummary);
      });
    });
  }

  onCodeChange(code: string) {
    this.getCampaignPricingSummary(code).then(() => {
      this.appliedDiscountCode = code;
    }, (e) => {
      this.appliedDiscountCode = '';
      // angular input setter won't trigger if the values are the same, need to set this to undefined so that next time it can retriger by empty string
      setTimeout(() => { this.appliedDiscountCode = undefined; })
    });
  }

}